module.exports = __webpack_public_path__ + "static/media/S.a3d6cc43.png";